<template>
    <div class="tab-pane" role="tabpanel" aria-labelledby="home-tab">



        <div class="row">
            <div class="col-md-12 overflow-auto">
                <b-table :stacked="($mobile == 1)" ref="table" class="vuetable" sort-by="id" sort-desc.sync="false"
                    :current-page="currentPage" :fields="bootstrapTable.fields" :items="dataProvider">
                 
                    
                    <template #cell(edit)="data">
                        <!-- :disabled="$role == 'teacher' && data.item.start_answers === 1" -->
                        <button class="btn btn-icon btn-warning btn-sm" @click="editItem(data)"
                           >
                            <i class="fa fa-edit" />
                        </button>
                        <button class="btn btn-icon btn-danger btn-sm" @click="deleteItem(data)"
                         >
                            <i class="fa fa-trash" />
                        </button>
                    </template>
                </b-table>
                <b-spinner v-if="load" type="grow" label="Loading..." class="loading" />
                <hr />
                <b-pagination v-model="currentPage" align="right"
                    class="dataTables_paginate paging_simple_numbers pagination-warning" :total-rows="totalRows"
                    :per-page="perPage">
                    <template v-slot:next-text>
                        <i class="fas fa-angle-left" />
                    </template>
                    <template v-slot:prev-text>
                        <i class="fas fa-angle-right" />
                    </template>
                    <template v-slot:first-text>
                        <i class="fas fa-step-forward" />
                    </template>
                    <template v-slot:last-text>
                        <i class="fas fa-step-backward" />
                    </template>
                </b-pagination>

                <!-- end of table -->
            </div>
            <!-- end of col -->
        </div>
        <!-- end of row -->



    </div>
</template>

<script>
import controller from "../../../../Controllers/ActivitiesController";
import quizVue from "./quiz.vue";

export default {
    name: "ActivitiesDataTable",
    props: ["items","editItem"],
    components: {
        quizVue,
    },
    data() {
        return {
            filters: {},
            bootstrapTable: {
                selected: [],
                selectMode: "multi",
                fields: [
                    {
                        key: "name",
                        label: this.$i18n.t("activities.name"),
                        sortable: true,
                        sortDirection: "desc",
                    },
                    {
                        key: "activity_type",
                        label: this.$i18n.t("activities.type"),
                        sortable: true,
                        sortDirection: "desc",
                    },
                    {
                        key: "from_date",
                        label: this.$i18n.t("activities.start_date"),
                        sortable: true,
                        sortDirection: "desc",
                    },
                    {
                        key: "to_date",
                        label: this.$i18n.t("activities.end_date"),
                        sortable: true,
                        sortDirection: "desc",
                    },
                    {
                        key: "eductional_level",
                        label: "الثمرة التعليمية",
                        sortable: true,
                        sortDirection: "desc",
                    },
                    {
                        key: "code",
                        label: "الكود",
                        sortable: true,
                        sortDirection: "desc",
                    },

                    { key: "edit", label: this.$i18n.t("site.action"), sortable: false },
                ],
            },
            data: {},
            selectAll: false,

            currentPage: 1,
            select: [],
            page: 1,
            perPage: 5,
            search: "",
            from: 0,
            total: 0,
            totalRows: 0,
            to: 0,
            lastPage: 0,
            load: false,
            apiParams: {},
            params: {},
        };
    },
    methods: {
        onPaginationData(paginationData) {
            this.$refs.pagination.setPaginationData(paginationData);
        },
        onChangePage(page) {
            this.$refs.vuetable.changePage(page);
        },
        async dataProvider(ctx) {
            this.load = true;
            this.params = ctx;
            const data = await new controller().GetAllNew(this.apiParamsConverter());
            this.currentPage = data.current_page;
            this.perPage = data.per_page;
            this.totalRows = data.total;
            this.from = data.from;
            this.to = data.to;
            this.total = data.total;
            this.data = data.data;
            this.load = false;
            return data.data;
        },
        apiParamsConverter() {
            const apiParams = { per_page: this.perPage };
            if (this.params.currentPage >= 1) {
                apiParams.page = this.params.currentPage;
            }
            if (this.params.sortBy && this.params.sortBy.length > 0) {
                apiParams.sort = `${this.params.sortBy}|${this.params.sortDesc ? "desc" : "asc"
                    }`;
            }
            // if (this.params.filter && this.params.filter.length > 0) {
            //   // Optional
            // }
            // if (this.search !== "") {
            //   apiParams.search = this.search;
            // }
            // if (this.filters.edu_course) {
            //   apiParams.edu_course = this.filters.edu_course;
            // }
            // if (this.filters.type) {
            //   apiParams.type = this.filters.type;
            // }
            // if (Auth.USER.account_type === "teacher") {
            //   apiParams.edu_program = localStorage.getItem("eduProgram");
            // }
            apiParams.with = ["assignment_and_projects_data","forums_data","short_exams_data.questions.answers"];
            console.log(apiParams);
            return apiParams;
        },
        changePageSize(perPage) {
            this.page = 1;
            this.perPage = perPage;
            this.dataProvider(this.params);
            this.$refs.table.refresh();
        },
        deleteItem(data){
            new controller().DeleteNew(data.item.id, [], this.$refs.table);
        },


    },
};
</script>